import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { type PolymorphicElementProps, type TagName } from '../types'

export type StackProps = ComponentPropsWithoutRef<TagName> & PolymorphicElementProps

export function Stack(props: StackProps): ReactElement {
  const { as = 'div', children, className, ...rest } = props

  const Component = as

  return (
    <Component className={clsx('display-stack', className)} {...rest}>
      {children}
    </Component>
  )
}
